import { useIntl } from 'react-intl';
import { Button, Checkbox, Dropdown, Icon, Table } from '../../../../ui';
import { MenuProps, message, Form } from 'antd';
import { useMemo, useState } from 'react';
import { CreateEditUser } from './CreateEditUser/CreateEditUser';
import { StyledBusinessTab } from '../style';
import { useAuth } from 'hooks/useAuth';
import useQueryApiClient from 'utils/useQueryApiClient';
import { ContactProps, FarmsProps } from 'interfaces/BackendModels';

interface ContactInformationProps {
  farm?: FarmsProps;
}

export const ContactInformation = ({ farm }: ContactInformationProps) => {
  const [reloadCount, setReloadCount] = useState<number>(0);
  const [isOpenEditCreateDrawer, setIsOpenEditCreateDrawer] =
    useState<boolean>(false);
  const [editContactId, setEditContactId] = useState<number | null>(null);
  const intl = useIntl();
  const { user } = useAuth();

  const stableFilter = useMemo(() => {
    return { farmId: user?.farmId };
  }, [user?.farmId]);

  const { appendData: deleteContact } = useQueryApiClient({
    request: {
      url: 'api/v2/farm/contacts/:id',
      method: 'DELETE',
    },
    onSuccess: () => {
      setReloadCount((prev: number) => prev + 1);
      message.success(
        intl.formatMessage({ id: 'message.sucess_contact_deleted' })
      );
    },
  });

  const handleEdit = (record: ContactProps) => {
    setEditContactId(record.id);
    setIsOpenEditCreateDrawer(true);
  };
  const handleDelete = (id: number) => {
    deleteContact([], { id: id });
  };
  const handleCloseDrawer = () => {
    setEditContactId(null);
    setIsOpenEditCreateDrawer(false);
  };

  const handleOpenEditCreateDrawer = () => {
    setIsOpenEditCreateDrawer(true);
  };

  const columns = [
    {
      title: intl.formatMessage({ id: 'farm_users.full_name_coma' }),
      dataIndex: 'full_name',
      render: (value: string) => value,
    },
    {
      title: intl.formatMessage({ id: 'general.telephone' }),
      dataIndex: 'contact_phone',
      render: (value: number) => value,
    },
    {
      title: intl.formatMessage({ id: 'general.email' }),
      dataIndex: 'contact_email',
      render: (value: string) => value,
    },
    {
      title: intl.formatMessage({ id: 'general.position' }),
      dataIndex: 'role',
      render: (value: string) => value,
    },
    {
      title: intl.formatMessage({ id: 'general.status' }),
      render: (record: ContactProps) => <Checkbox checked={record?.status} />,
      className: 'centered-column',
      align: 'center',
    },
    {
      title: intl.formatMessage({ id: 'general.actions' }),
      render: (record: ContactProps) => {
        const items: MenuProps['items'] = [
          {
            key: 'edit',
            label: intl.formatMessage({ id: 'general.edit' }),
            onClick: () => handleEdit(record),
          },
          {
            key: 'delete',
            label: intl.formatMessage({ id: 'general.delete' }),
            onClick: () => handleDelete(record.id),
          },
        ];

        return (
          <Dropdown menu={{ items }} trigger={['click']} key={record.id}>
            <Button
              label={intl.formatMessage({ id: 'general.actions' })}
              disabled={record.deleted_at != null}
              icon={<Icon name={'arrow-down-black'} type={'any'} />}
              iconPosition={'end'}
            />
          </Dropdown>
        );
      },
    },
  ];

  return (
    <StyledBusinessTab>
      <Button
        label={intl.formatMessage({ id: 'general.add_new_contact_user' })}
        type={'primary'}
        className={'new-btn'}
        onClick={handleOpenEditCreateDrawer}
      />
      <Table
        url={'/api/v2/farm/contacts'}
        columns={columns}
        reload={reloadCount}
        filter={stableFilter}
      />
      <CreateEditUser
        open={isOpenEditCreateDrawer}
        editContactId={editContactId}
        setReloadCount={setReloadCount}
        onClose={handleCloseDrawer}
      />
    </StyledBusinessTab>
  );
};
